<template>
    <b-container v-if="getUpsellingSorted && getUpsellingSorted.length > 0" class="">
   
        <div class="card-columns mt-5">
            <shop-upselling-item
            v-for="ShopProductItem in getUpsellingSorted"
            :key="ShopProductItem.id"        
            :ShopProductItem="ShopProductItem"/> 
      </div>  
    </b-container>         
</template>


<script>
import ShopUpsellingItem from "@/components/ShopUpsellingItem";

export default {
    name: 'ShopUpsellingPanel',
    props: ['upSellingProducts'],
    components:{ShopUpsellingItem},
    data(){
        return {            
            
        }
    },
    computed: {
         getSelectedLanguage() {
            return this.$store.getters.getLanguage;
        },
        getLanguageItem: function() {
            return this.$store.getters.getLanguageStrings;
        },
        getUpsellingSorted(){
           // console.log('Sorted upselling: ', this.upSellingProducts);
            // show only unique items, no dublicates
            return this.uniqBy(this.upSellingProducts, 'id');
        },        

    },
    methods: {
        uniqBy(arr, comp) { // returns array with unique items, no dudlicates! for object arrays
            const unique = arr
            .map(e => e[comp])

            // store the keys of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)

            // eliminate the dead keys & store unique objects
            .filter(e => arr[e]).map(e => arr[e]);

            return unique;
        },
        
    },
    beforeMount(){

    }

}
</script>
